import { Field, FieldControllerType } from '@gemini/lux-ds-pms';
import { StaticValues } from '@utils/enums/StaticValues.enum';
import { InsuranceDTO } from '@utils/interfaces';

const insuranceForm = (insurances: InsuranceDTO): Field[] => {
  return [
    {
      id: 'insurance.plan',
      labelKey: 'insurancePage.labels.insurancePlan',
      type: FieldControllerType.RADIO,
      visibility: true,
      disabled: false,
      size: {
        xs: 12,
        md: 12,
        lg: 12,
      },
      options: [
        { key: StaticValues.YES, label: 'insurancePage.fieldsLabel.yes' },
        { key: StaticValues.NO, label: 'insurancePage.fieldsLabel.no' },
      ],
      validations: [
        {
          type: 'required',
          value: true,
          errorMsgKey: 'fieldsLabel.errors.isRequired',
        },
      ],
    },
    {
      id: 'insurance.id',
      labelKey: 'insurancePage.labels.insuranceName',
      type: FieldControllerType.DROPDOWN,
      visibility: true,
      disabled: false,
      size: {
        xs: 12,
        md: 6,
        lg: 6,
      },
      options: [
        ...insurances.map(insurance => ({
          key: insurance.insuranceId.toString(),
          label: insurance.name,
          type: insurance.type,
        })),
      ],
      validations: [
        {
          type: 'required',
          value: true,
          errorMsgKey: 'fieldsLabel.errors.isRequired',
        },
      ],
      visibilityCondition: {
        conditions: [{ idRef: 'insurance.plan', valueRef: StaticValues.YES }],
      },
    },
    {
      id: 'insurance.other',
      labelKey: 'insurancePage.labels.otherInsurance',
      type: FieldControllerType.TEXT,
      visibility: true,
      disabled: false,
      size: {
        xs: 12,
        md: 6,
        lg: 6,
      },
      validations: [
        {
          type: 'required',
          value: true,
          errorMsgKey: 'fieldsLabel.errors.isRequired',
        },
      ],
      visibilityCondition: {
        type: 'AND',
        conditions: [
          { idRef: 'insurance.plan', valueRef: StaticValues.YES },
          { idRef: 'insurance.id', valueRef: StaticValues.OTHER_OPTION },
        ],
      },
    },
  ];
};

export default insuranceForm;
